import { render, staticRenderFns } from "./appointmentHome.vue?vue&type=template&id=38d17f34&scoped=true&"
import script from "./appointmentHome.vue?vue&type=script&lang=js&"
export * from "./appointmentHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d17f34",
  null
  
)

export default component.exports